import React, { useState } from 'react';
import Messages from '../../../../../Localization/Messages';
import { formatMessage } from '../../../../../Localization/formatMessage';
import { modalType } from '../../../OpenedModalType';
import { useTeamPageContext } from '../../../TeamPage';
import { teamPageReducerTypes } from '../../../Reducer';
import MenuList from '../../../../../Elements/MenuList';
import MenuListItem from '../../../../../Elements/MenuListItem';
import { isAgentActive } from '../../../../../Helpers/AgentHelper';
import { PresentationMode } from '../../../../../Enums/PresentationMode';
import ThreeDotIcon from '../../../../../Elements/ids/ThreeDotIcon';
import { areBrokerFunctionsAvailable } from '../../../Functions';

const TeamHeaderMenu = ({ team }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { teamPageDispatch, pageState } = useTeamPageContext();

  const dispatchSetOpenedModal = modalType => {
    teamPageDispatch({
      type: teamPageReducerTypes.setOpenedModal,
      payload: {
        modalType: modalType,
        modalAgent: {},
      },
    });
    setIsOpen(false);
  };

  return (
    <>
      <ThreeDotIcon
        onClick={() => {
          setIsOpen(true);
        }}
      />

      <MenuList
        isOpen={isOpen}
        onOutsideClick={() => {
          setIsOpen(false);
        }}>
        <MenuListItem
          text={formatMessage(Messages.common_edit)}
          onClick={() => {
            dispatchSetOpenedModal(modalType.TeamInfo);
          }}
        />
        {pageState.pageMode !== PresentationMode.Add && (
          <>
            {areBrokerFunctionsAvailable(team) && (
              <MenuListItem
                text={formatMessage(Messages.headerMenu_viewBankLog)}
                onClick={() => {
                  dispatchSetOpenedModal(modalType.BankLog);
                }}
                disabled={!team?.agents?.some(isAgentActive)}
              />
            )}
            <MenuListItem
              text={formatMessage(Messages.headerMenu_copyCostCenters)}
              onClick={() => {
                dispatchSetOpenedModal(modalType.CopyCostCenter);
              }}
              disabled={!team?.agents?.some(isAgentActive)}
            />
            <MenuListItem
              text={formatMessage(Messages.headerMenu_editAddress)}
              onClick={() => {
                dispatchSetOpenedModal(modalType.AddressInfo);
              }}
            />
            <MenuListItem
              text={formatMessage(Messages.headerMenu_viewAddressLog)}
              onClick={() => {
                dispatchSetOpenedModal(modalType.AddressLog);
              }}
            />
            <MenuListItem
              text={formatMessage(Messages.headerMenu_openHierarchyView)}
              onClick={() => {
                dispatchSetOpenedModal(modalType.TeamHierarchy);
              }}
            />
          </>
        )}
      </MenuList>
    </>
  );
};

export default TeamHeaderMenu;
